<template>
    <el-row v-if="amReady">
        <div class="mb-5 border-bottom">
            <h3>{{ ((!editMode)? $ml.get('create') : $ml.get('edit') ) + ' ' + module.info.caption}}</h3>
        </div>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                field_mark="required"
                label="username"
                name="Username"
                placeholder="Jikatel"
                rules="required"></dg-text-field>

            <dg-select-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                :options="codecsList"
                :translateLabels="false"
                field_mark="required"
                label="codec"
                name="codec"
                rules="required"></dg-select-field>

        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                field_mark="required"
                label="password"
                name="password"
                placeholder="secret"
                rules="required"
                type="password"></dg-text-field>

            <dg-select-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                :options="fusionServerList"
                :translateLabels="false"
                field_mark="required"
                label="fusion_server"
                name="fusion_server"
                rules="required"></dg-select-field>
        </el-col>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                field_mark="required"
                label="nickname"
                name="nickname"
                placeholder="Phenox Lufe"
                rules="required"></dg-text-field>

        </el-col>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="controller"
                :field_span="19"
                :label_span="24"
                field_mark="required"
                label="user_link_for_vos_login"
                name="nickname"
                placeholder="https://vos.jikatel.com"
                rules="required"></dg-text-field>
        </el-col>

      <el-col :span="24" v-loading="loadingRequests" class="mt-5 border-top">
          <el-col :span="20" class="mt-4" :class="$langConfig.cssClass">
            <dg-label-field v-show="!this.validData" class="error-field-validate-message"
                         label="fields_do_not_match_the_required_criteria"></dg-label-field>
          </el-col>
          <el-col :span="4" class="pt-3 text-right">
            <dg-button
                icon="el-icon-plus mr-2"
                :text="actionButtonLabel"
                :type="actionButtonType"
                :click="createModule"></dg-button>
          </el-col>
      </el-col>
    </el-row>
</template>

<script>
    import Vue from 'vue'
    import {mapState} from 'vuex'
    import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
    import module from './../index.js'

    export default {
        mixins: [fieldController],
        props: {
            editMode: {
                required: true,
                type: Boolean
            },
            onEditCallback: {
                required: false
            },
            onCreateCallback: {
                required: false
            }
        },
        data() {
            return {
                controller: this,
                amReady: true,
                module: {
                    ...module
                },
                dataModel: {},
                fusionServerList: [
                    {
                        'label': 'London',
                        'value': '142.12.44.90'
                    },
                    {
                        'label': 'Singapora',
                        'value': '162.75.21.1'
                    }
                ],
                codecsList: [
                    {
                        'label': 'G729',
                        'value': 'G729'
                    },
                    {
                        'label': 'G711',
                        'value': 'G711'
                    }
                ]
            }
        },
        computed: {
            ...mapState('ajaxManager', ['loadingRequests']),
            actionButtonLabel: function () {
                if (!this.editMode) {
                    return 'create';
                } else {
                    return 'edit'
                }
            },
            actionButtonType: function () {
                if (!this.validData) {
                    return 'danger';
                } else {
                    return 'primary app-bg-primary'
                }
            }
        },
        methods: {
            createModule() {
                this.validateFields().then(result => {
                    let context = this;
                    let data = {data: this.dataModel};
                    if (this.editMode) {
                        data.id = this.dataToBind.id;
                    }

                    if (result) {
                        let api = (this.editMode) ? 'update' : 'create';
                        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
                            G_toastNotify({
                                type: 'success',
                                title: this.$ml.get(api + 'd'),
                                priority: 'top',
                                timer: 4000
                            });

                            this.amReady = false

                            if (context.editMode) {
                                context.onEditCallback(response.data)
                            } else {
                                Vue.nextTick(() => {
                                    context.amReady = true
                                })
                                if (context.onCreateCallback) {
                                    context.onCreateCallback(response.data)
                                }
                            }
                            // this.$router.push({ name: this.module.stateName + '-module-list', params: { teacherId: response.data.id}}).then( response => {})
                        }).catch(error => {
                            this.setfieldsErrorMessage({
                                fieldsErrors: error.response.data
                            }, this.arefieldsValid);
                        })
                    }
                })
            }
        }
    }
</script>
